var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91667 0C1.30583 0 0 1.30583 0 2.91667V11.875C0 13.6009 1.39911 15 3.125 15H12.7083C13.974 15 15 13.974 15 12.7083V6.45833C15 5.19268 13.974 4.16667 12.7083 4.16667H11.6667V1.85049C11.6667 0.828492 10.8382 0 9.81617 0H2.91667ZM10.4167 4.16667V1.85049C10.4167 1.51885 10.1478 1.25 9.81617 1.25H2.91667C1.99619 1.25 1.25 1.99619 1.25 2.91667C1.25 3.60702 1.80964 4.16667 2.5 4.16667H10.4167ZM10.4167 10.4167C10.8769 10.4167 11.25 10.0436 11.25 9.58333C11.25 9.12308 10.8769 8.75 10.4167 8.75C9.95642 8.75 9.58333 9.12308 9.58333 9.58333C9.58333 10.0436 9.95642 10.4167 10.4167 10.4167Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletPay);
export default __webpack_public_path__ + "static/media/wallet-pay.7e0b5997251aada9e01be1a1c1cc9bea.svg";
export { ForwardRef as ReactComponent };